import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Progress } from 'antd';

const POIUploadStatus = (props) => {
  const percent = Math.ceil((props.currentPage / props.totalPages) * 100);

  return(
    <div style={{ width: '100%', height: '100%', textAlign: 'center', paddingTop: '18%' }}>
    {props.failed.length > 0 ? (
      <div>
        <h2>{props.failed.length} failed POIs</h2>
        <code>
          {JSON.stringify(props.failed)}
        </code>
      </div>
    ): null}
      <Progress type="circle" percent={percent} /> 
    </div>
  )
}

POIUploadStatus.propTypes = {
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  failed: PropTypes.array,
}

// Map props to the store

const mapStateToProps = (state) => {
  return {
    totalPages: state.routes.organizations.upload.get('totalPages'),
    currentPage: state.routes.organizations.upload.get('currentPage'),
    failed: state.routes.organizations.upload.get('failed'),
  }
}

const mapDispatchToProps = () => ({
})

const POIUploadStatusContainer = connect(mapStateToProps,mapDispatchToProps)(POIUploadStatus);

export default POIUploadStatusContainer;


// WEBPACK FOOTER //
// ./src/organizations/components/POIUploadStatus.js